import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/shared/components/ui/dialog";
import { Button } from "@/shared/components/ui/button";
import { AlertTriangle } from "lucide-react";
import type { ClientResponseDTO } from "../types/client.types";
import { memo } from "react";

interface ClientDeleteDialogProps {
  open: boolean;
  loading: boolean;
  client: ClientResponseDTO | null;
  onClose: () => void;
  onConfirm: () => void;
}

export const ClientDeleteDialog = memo(function ClientDeleteDialog({
  open,
  loading,
  client,
  onClose,
  onConfirm,
}: ClientDeleteDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Excluir Cliente</DialogTitle>
          <DialogDescription>
            Tem certeza que deseja excluir este cliente?
          </DialogDescription>
        </DialogHeader>
        <div className="py-4">
          <div className="p-4 bg-destructive/10 rounded-md border border-destructive/20">
            <div className="flex items-start gap-3">
              <AlertTriangle className="w-5 h-5 text-destructive shrink-0 mt-0.5" />
              <div>
                <p className="font-semibold">{client?.name}</p>
                <p className="text-sm text-muted-foreground">
                  {client?.document}
                </p>
                <p className="text-sm text-muted-foreground">{client?.phone}</p>
                <p className="text-sm text-destructive mt-2">
                  Esta ação não pode ser desfeita!
                </p>
              </div>
            </div>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={loading}>
            Cancelar
          </Button>
          <Button variant="destructive" onClick={onConfirm} disabled={loading}>
            {loading ? "Excluindo..." : "Excluir Cliente"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
});
